import React from "react";
import { Globe, Mail, RefreshCw, ShieldCheck, X } from "lucide-react";
import { formatLicensedRegions } from "../constants/geoRestriction";
import "../geo-restriction.css";

const GeoRestrictedScreen = ({
  message,
  country,
  licensedRegions = ["RW"],
  onRetry,
  retrying = false,
}) => {
  const regionLabel = formatLicensedRegions(licensedRegions);

  return (
    <div className="geo-restricted-page" role="main" aria-labelledby="geo-restricted-title">
      <div className="geo-restricted-glow geo-restricted-glow-a" aria-hidden />
      <div className="geo-restricted-glow geo-restricted-glow-b" aria-hidden />

      <div className="geo-restricted-inner">
        <div className="geo-restricted-icon-wrap" aria-hidden>
          <span className="geo-restricted-icon-ring">
            <Globe size={44} strokeWidth={1.75} />
          </span>
          <span className="geo-restricted-icon-badge">
            <X size={16} strokeWidth={2.75} />
          </span>
        </div>

        <p className="geo-restricted-kicker">Regional access</p>
        <h1 id="geo-restricted-title" className="geo-restricted-title">
          Not available in your current region
        </h1>

        <p className="geo-restricted-body">{message}</p>

        <div className="geo-restricted-card">
          <ShieldCheck size={22} className="geo-restricted-card-icon" aria-hidden />
          <p>
            BetBond is offered only in <strong>{regionLabel}</strong>, where we operate under
            local licensing. If you are travelling or using a VPN, try again when you are in a
            supported location.
          </p>
        </div>

        {country ? (
          <p className="geo-restricted-meta">Detected region code: {country}</p>
        ) : null}

        <div className="geo-restricted-actions">
          <button
            type="button"
            className="geo-restricted-btn geo-restricted-btn-primary"
            onClick={onRetry}
            disabled={retrying}
          >
            <RefreshCw size={16} className={retrying ? "geo-restricted-spin" : ""} aria-hidden />
            {retrying ? "Checking again…" : "Check again"}
          </button>

          <a className="geo-restricted-btn geo-restricted-btn-secondary" href="mailto:betbondofficial@gmail.com">
            <Mail size={16} aria-hidden />
            Contact support
          </a>
        </div>

        <p className="geo-restricted-foot">© BetBond · 18+ only · Licensed territory required</p>
      </div>
    </div>
  );
};

export default GeoRestrictedScreen;
